import axios from "axios";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Spinner,
} from "react-bootstrap";
import { FaEnvelope, FaLock, FaPhone, FaUser } from "react-icons/fa";
import "../../../assets/css/Customer/CustomerAuth/CustomerSignup.css";
import logo from "../../../assets/images/logo.png";
import AppContext from "../../../context/AppContext";

const CustomerSignup = () => {
  const { baseUrl, RegExpChecker, formatPhoneNumber } = useContext(AppContext);
  const [customerName, setCustomerName] = useState("");
  const [customerEmail, setcustomerEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
  });

  const navigate = useNavigate();

  const isFormValid =
    customerName &&
    customerEmail &&
    mobileNumber &&
    password &&
    !errors.username &&
    !errors.email &&
    !errors.phone &&
    !errors.password;

  // Ek hi jagah se field ka error set karne ke liye helper
  const validateField = (field, type, value) => {
    const regError = RegExpChecker(type, value);
    setErrors((prev) => ({
      ...prev,
      [field]: value && regError ? regError : "",
    }));
  };

  const handleSignup = () => {
    if (!isFormValid) return;
    setLoading(true);

    const formdata = new FormData();
    formdata.append("customerName", customerName.trim());
    formdata.append("mobileNumber", mobileNumber);
    formdata.append("customerEmail", customerEmail.trim());
    formdata.append("password", password);

    axios
      .post(`${baseUrl}/customer/profile/createCustomer`, formdata)
      .then((response) => {
        setLoading(false);
        if (response.data.hasOwnProperty("error")) {
          // Error par form clear nahi hota, user dobara sab kuch na likhe
          alert("Error: " + response.data.error);
        } else {
          setCustomerName("");
          setcustomerEmail("");
          setMobileNumber("");
          setPassword("");
          alert("Account Created Successfully!");
          navigate("/customer-login");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  return (
    <div className="CustomerSignup-wrapper">
      <Container className="CustomerSignup-container">
        <Row className="justify-content-center">
          <Col xs={12}>
            <div className="CustomerSignup-header">
              <div className="CustomerSignup-logo-wrapper">
                <img
                  src={logo}
                  alt="TrustiDrive Logo"
                  className="CustomerSignup-logo-img"
                />
              </div>
              <p className="CustomerSignup-role">customer</p>
            </div>

            <div className="CustomerSignup-form-section">
              <h2 className="CustomerSignup-title">Create your account</h2>
              <p className="CustomerSignup-subtitle">
                Explore your life by joining with Ride.
              </p>

              <Form onSubmit={(e) => e.preventDefault()}>
                {/* User Name */}
                <Form.Group className="CustomerSignup-form-group">
                  <Form.Label className="CustomerSignup-label">
                    User Name
                  </Form.Label>
                  <InputGroup className="CustomerSignup-input-group">
                    <InputGroup.Text className="CustomerSignup-input-icon-box">
                      <FaUser className="CustomerSignup-icon" />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="userName"
                      placeholder="Enter your name"
                      value={customerName}
                      onChange={(e) => {
                        const value = e.target.value;
                        setCustomerName(value);
                        validateField("username", "username", value);
                      }}
                    />
                  </InputGroup>
                  {errors.username && (
                    <small className="text-danger">{errors.username}</small>
                  )}
                </Form.Group>

                {/* Mobile Number */}
                <Form.Group className="CustomerSignup-form-group">
                  <Form.Label className="CustomerSignup-label">
                    Mobile Number
                  </Form.Label>
                  <InputGroup className="CustomerSignup-input-group">
                    <InputGroup.Text className="CustomerSignup-input-icon-box">
                      <FaPhone className="CustomerSignup-icon" />
                    </InputGroup.Text>
                    <Form.Control
                      type="tel"
                      name="mobileNumber"
                      inputMode="numeric"
                      placeholder="0300-9988998"
                      maxLength={12}
                      value={mobileNumber}
                      onChange={(e) => {
                        const formatted = formatPhoneNumber(e.target.value);
                        setMobileNumber(formatted);
                        validateField("phone", "phonenumber", formatted);
                      }}
                    />
                  </InputGroup>
                  {errors.phone && (
                    <small className="text-danger">{errors.phone}</small>
                  )}
                </Form.Group>

                {/* Email */}
                <Form.Group className="CustomerSignup-form-group">
                  <Form.Label className="CustomerSignup-label">
                    Email
                  </Form.Label>
                  <InputGroup className="CustomerSignup-input-group">
                    <InputGroup.Text className="CustomerSignup-input-icon-box">
                      <FaEnvelope className="CustomerSignup-icon" />
                    </InputGroup.Text>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      value={customerEmail}
                      onChange={(e) => {
                        const value = e.target.value;
                        setcustomerEmail(value);
                        validateField("email", "email", value.trim());
                      }}
                    />
                  </InputGroup>
                  {errors.email && (
                    <small className="text-danger">{errors.email}</small>
                  )}
                </Form.Group>

                {/* Password */}
                <Form.Group className="CustomerSignup-form-group">
                  <Form.Label className="CustomerSignup-label">
                    Password
                  </Form.Label>
                  <InputGroup className="CustomerSignup-input-group">
                    <InputGroup.Text className="CustomerSignup-input-icon-box">
                      <FaLock className="CustomerSignup-icon" />
                    </InputGroup.Text>
                    <Form.Control
                      type="password"
                      name="Password"
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => {
                        const value = e.target.value;
                        setPassword(value);
                        validateField("password", "password", value);
                      }}
                    />
                  </InputGroup>
                  {errors.password && (
                    <small className="text-danger">{errors.password}</small>
                  )}
                </Form.Group>

                {/* Submit button */}
                <Button
                  className="CustomerSignup-btn"
                  onClick={handleSignup}
                  disabled={!isFormValid || loading}
                >
                  {loading ? (
                    <div className="btn-content-wrapper">
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      <span className="ms-2">Loading...</span>
                    </div>
                  ) : (
                    "Sign Up"
                  )}
                </Button>

                {/* Sign in link */}
                <div className="CustomerSignup-footer">
                  <span className="CustomerSignup-footer-text">
                    Already have an account?{" "}
                  </span>
                  <button
                    type="button"
                    onClick={() => navigate("/customer-login")}
                    className="CustomerSignup-link"
                  >
                    Sign in
                  </button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CustomerSignup;